import React from "react";
import { BrowserRouter, Switch } from "react-router-dom";
import { ToastContainer } from "react-toastify";

import LoggedInLayout from "../layout";
import Dashboard from "../pages/Dashboard/";
import Tickets from "../pages/Tickets/";
import Signup from "../pages/Signup/";
import Login from "../pages/Login/";
import ForgotPassword from "../pages/ForgotPassword/";
import ResetPassword from "../pages/ResetPassword/";
import Settings from "../pages/Settings/";
import Users from "../pages/Users";
import Contacts from "../pages/Contacts/";
import QuickAnswers from "../pages/QuickAnswers/";
import Queues from "../pages/Queues/";
import Tags from "../pages/Tags/";
import Kanban from "../pages/Kanban/";
import Tasks from "../pages/Tasks/";
import Reports from "../pages/Reports/";
import InternalChat from "../pages/InternalChat/";
import MetaIntegration from "../pages/MetaIntegration/";
import Campaigns from "../pages/Campaigns/";
import ContentCalendar from "../pages/ContentCalendar/";
import ScheduledMessages from "../pages/ScheduledMessages/";
import Departments from "../pages/Departments/";
import Chatbot from "../pages/Chatbot/";
import { AuthProvider } from "../context/Auth/AuthContext";
import { WhatsAppsProvider } from "../context/WhatsApp/WhatsAppsContext";
import { ThemeProvider } from "../context/DarkMode";
import { ChatAppearanceProvider } from "../context/ChatAppearance";
import Route from "./Route";

const Routes = () => {
  return (
    <BrowserRouter>
      <AuthProvider>
        <ThemeProvider>
          <Switch>
            <Route exact path="/login" component={Login} />
            <Route exact path="/signup" component={Signup} />
            <Route exact path="/forgot-password" component={ForgotPassword} />
            <Route exact path="/reset-password" component={ResetPassword} />
            <WhatsAppsProvider>
              <ChatAppearanceProvider>
              <LoggedInLayout>
                <Route exact path="/" component={Dashboard} isPrivate />
                <Route exact path="/tickets/:ticketId?" component={Tickets} isPrivate />
                <Route exact path="/connections" component={MetaIntegration} isPrivate />
                <Route exact path="/contacts" component={Contacts} isPrivate />
                <Route exact path="/users" component={Users} isPrivate />
                <Route exact path="/quickAnswers" component={QuickAnswers} isPrivate />
                <Route exact path="/tags" component={Tags} isPrivate />
                <Route exact path="/kanban" component={Kanban} isPrivate />
                <Route exact path="/tasks" component={Tasks} isPrivate />
                <Route exact path="/reports" component={Reports} isPrivate />
                <Route exact path="/internal-chat" component={InternalChat} isPrivate />
                <Route exact path="/meta" component={MetaIntegration} isPrivate />
                <Route exact path="/campaigns" component={Campaigns} isPrivate />
                <Route exact path="/content-calendar" component={ContentCalendar} isPrivate />
                <Route exact path="/scheduled-messages" component={ScheduledMessages} isPrivate />
                <Route exact path="/departments" component={Departments} isPrivate />
                <Route exact path="/chatbot" component={Chatbot} isPrivate />
                <Route exact path="/Settings" component={Settings} isPrivate />
                <Route exact path="/Queues" component={Queues} isPrivate />
              </LoggedInLayout>
              </ChatAppearanceProvider>
            </WhatsAppsProvider>
          </Switch>
          <ToastContainer autoClose={3000} />
        </ThemeProvider>
      </AuthProvider>
    </BrowserRouter>
  );
};

export default Routes;
